import { render, staticRenderFns } from "./branch-item.vue?vue&type=template&id=34e1a828&"
import script from "./branch-item.vue?vue&type=script&lang=js&"
export * from "./branch-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e1a828')) {
      api.createRecord('34e1a828', component.options)
    } else {
      api.reload('34e1a828', component.options)
    }
    module.hot.accept("./branch-item.vue?vue&type=template&id=34e1a828&", function () {
      api.rerender('34e1a828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/branch-item/branch-item.vue"
export default component.exports